import React from 'react';
import { Props } from '../ThumbView';
import UnknownDumbView from '../../../DeviationViews/Dumbo/Unknown';

import s from './Unknown.scss';

const UnknownThumbReactView: React.FC<Props> = ({
  width,
  height,
  deviation,
}) => (
  <div className={s['root']}>
    <UnknownDumbView width={width} height={height} deviation={deviation} />
  </div>
);
UnknownThumbReactView.displayName = 'UnknownThumbReactView';

export default UnknownThumbReactView;
